<template>
  <div>
    <v-dialog v-model="show" max-width="500" persistent scrollable>
      <v-card>
        <!-- dialog header -->
        <v-card-title class="text-h6 font-weight-black pt-4 pb-2">
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn icon @click="Close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- dialog body -->
        <v-card-text>
          <cropper
            class="cropper"
            ref="cropper"
            :src="image.src"
            :default-size="defaultSize"
            stencil-component="circle-stencil"
          />
        </v-card-text>
        <v-card-text>
          {{ str.alert }}
        </v-card-text>
        <!-- dialog footer -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="primary" text @click="Close()">
            {{ str.cancel }}
          </v-btn>
          <!-- 單選 確定按鈕樣式 -->
          <v-btn elevation="0" color="primary" @click="Confirm()">
            <div class="white--text">{{ str.confirm }}</div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// #region 照片裁切套件
// https://norserium.github.io/vue-advanced-cropper/
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import "vue-advanced-cropper/dist/theme.classic.css";
// import { saveAs } from "file-saver";

// This function is used to detect the actual image type,
function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

//#endregion

export default {
  components: {
    Cropper,
  },
  props: {
    open: Boolean,
    imgFile: File,
  },
  data() {
    return {
      show: false,
      str: {
        confirm: "確定",
        cancel: "取消",
        alert: "※使用滑鼠滾輪(電腦)或縮放手勢(行動裝置)可縮放圖片",
      },
      title: "編輯圖片",
      imgFiles: null,
      imgFileName: "",
      image: {
        src: null,
        type: null,
      },
      zoom: 0,
      url: "",
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
    };
  },
  watch: {
    imgFile() {
      if (this.imgFile !== null) {
        this.loadImage(this.imgFile);
      }
    },
    open(val) {
      this.show = val;
    },
    // 父層驗證表單的錯誤訊息捕捉並反饋
    errorMsg() {
      this.comp.errorMsg = this.errorMsg;
    },
    disabled() {
      this.comp.disabled = this.disabled;
    },
    deep: true,
  },
  mounted() {},
  methods: {
    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },
    Confirm() {
      this.crop();
    },
    // 剪裁 按確認按鈕再過去
    crop() {
      const { canvas } = this.$refs.cropper.getResult();
      if (canvas !== undefined) {
        canvas.toBlob(
          (blob) => {
            //   saveAs(blob);
            let myfile = new File(
              [blob],
              `${this.removeExtension(this.imgFileName)}.webp`
            );
            this.EmitValue(myfile);
            // this.EmitValue(blob);
          },
          "image/webp",
          0.5
        ); // 2022.09.22 為調整圖片載入速度，圖片一律改存webp
        // }, this.image.type);
      }
    },
    // 讀檔案
    loadImage(file) {
      // file to blob
      this.imgFileName = file.name;
      if (file) {
        if (this.image.src) URL.revokeObjectURL(this.image.src);
        const blob = URL.createObjectURL(file);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = {
            src: blob,
            type: getMimeType(e.target.result, file.type),
          };
        };
        reader.readAsArrayBuffer(file);
      }
    },

    // 重設錯誤訊息
    ResetValidation() {
      this.comp.errorMsg = "";
    },
    // 關閉彈窗
    Close() {
      this.show = false;
      this.$emit("close", true);
    },
    // 回傳檔案
    EmitValue(blob) {
      this.$emit("files", blob);
    },
    // 去附檔名
    removeExtension(fileName) {
      let extIndex = fileName.lastIndexOf(".");
      if (extIndex != -1) {
        return fileName.substr(0, extIndex);
      }
    },
  },
  destroyed() {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style>
.img-hw {
  height: 387px;
  width: 140px;
}
.cropper {
  background: rgb(0, 0, 0, 0.06);
  border-radius: 8px;
  /* background-image: url("~@/assets/images/illustration/bg-img.svg"); */
  background-repeat: no-repeat;
  background-position: center;
  height: 400px;
  max-width: 100%;
}
.v-slider--horizontal {
  min-height: 24px !important;
}
</style>
